import React, { useEffect, useState } from "react";
import OnboardingExpertDataService from "../../services/OnboardingExpert";
import { useParams } from "react-router-dom";
import {
  Box,
  Container,
  Text,
  Stack,
  VStack,
  HStack,
  Divider,
  Badge,
  useColorModeValue,
  Link,
} from "@chakra-ui/react";
import { FaCheck, FaTimes } from "react-icons/fa";
export const OnboardingExpertView = () => {
  const { id } = useParams();
  const [data, setData] = useState({
    questions: [],
  });
  const fetchData = () => {
    OnboardingExpertDataService.getSingleOnboardingExpert(id)
      .then((res: any) => {
        setData(res.data);
      })
      .catch((error: Error) => {
        console.log(error);
      });
  };

  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="page_title py-2">Experts - App Experts Onboarding</div>
      <Container
        maxW="container.xxl"
        p={4}
        bg={bg}
        borderRadius="lg"
        boxShadow="xl"
      >
        <Stack spacing={6}>
          {data.questions.map((q: any) => (
            <Box
              key={q.question_id}
              p={5}
              borderWidth="1px"
              borderRadius="lg"
              borderColor={borderColor}
              boxShadow="md"
            >
              <VStack align="start" spacing={3}>
                <HStack>
                  <Text fontSize="lg" fontWeight="bold">
                    {q.question_text}
                  </Text>
                  {q.mandatory && (
                    <sup
                      style={{
                        fontSize: "30px",
                        color: "red",
                        verticalAlign: "super",
                        marginTop: "5px",
                      }}
                    >
                      *
                    </sup>
                  )}
                </HStack>
                {["checkbox", "radiobutton"].includes(q.question_type) ? (
                  <VStack align="start" spacing={2}>
                    {q.answer_data.map((answer: any, idx: any) => (
                      <HStack key={idx} alignItems="center">
                        <Badge colorScheme={answer.value ? "green" : "red"}>
                          {answer.value ? <FaCheck /> : <FaTimes />}
                        </Badge>
                        <Text>{answer.label}</Text>
                      </HStack>
                    ))}
                  </VStack>
                ) : q.question_type === "document" && q.answer_data[0].label ? (
                  <Link
                    href={q.answer_data[0].label}
                    isExternal
                    fontSize="md"
                    color="blue.500"
                  >
                    {q.answer_data[0].label}
                  </Link>
                ) : (
                  <Text fontSize="md" color="gray.600">
                    {q.answer_data[0].label || "No answer provided"}
                  </Text>
                )}
                <Divider />
              </VStack>
            </Box>
          ))}
        </Stack>
      </Container>
    </>
  );
};
